import axios, { AxiosResponse } from "axios";

import { IPaginationConfig } from "./stats-external-client.types";

export const loadRegionData = async (): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/tax-org/search`, {
        params: {
            levels: "1,2",
        },
    });
};

export const saveFile = (data: Blob, type: string, title = "template.xlsx") => {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = title;
    link.click();
    link.remove();
};

// report

export const searchTrade = (config?: IPaginationConfig): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/international-trade-report', {
        params: config,
    });
};

export const downloadDocumentTrade = (fileId: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/international-trade-report/download/${fileId}`, {
        responseType: "arraybuffer",
    });
};

// index

export const searchIndex = (config?: IPaginationConfig): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/international-trade-index', {
        params: {
            ...config,
        },
    });
};

export const downloadDocumentIndex = (fileId: string): Promise<AxiosResponse> => {
    return axios.get(`/services/isnaportal/open-api/international-trade-index/download/${fileId}`, {
        responseType: "arraybuffer",
    });
};
